import { useState, useEffect } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import logo from "../assets/l2.png"; // replace with your logo
import Topbar from "./Topbar";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [active, setActive] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  // Close mobile menu automatically on resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 800) {
        setIsOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    {
      name: "Services",
      dropdown: [
        { name: "Drone Health Check", href: "/drone_health_check" },
        { name: "Repair & Maintenance + Spare Parts Hub", href: "/repair_and_maintenance" },
        { name: "Advisory & Data Analytics", href: "/smartfarming" },
        { name: "Technical Support Helpdesk", href: "/helpdesk" },
      ],
    },
        { name: "Sustainability", href: "/sustainability" },
        // { name: "Blog", href: "/blog" },
    { name: "Contact", href: "/contact" },
  ];

  return (
    <>
    <Topbar/>
      <nav
      className={`fixed left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-[#f6f3df] shadow-2xl h-16" : "bg-transparent h-20"
      }`}
    >
  <div
  className={`relative flex items-center h-full border-t-2 border-b-2 border-green-900 backdrop-blur-md shadow transition-all duration-500 ${
    scrolled
      ? "max-w-full top-0 "
      : "max-w-6xl top-0 md:top-9 lg:top-8 mt-4 bg-[#f6f3df]"
  } mx-auto px-10`}
>
  {/* ✅ Left - Logo */}
<div className="absolute transition-all duration-300" style={{ top: scrolled ? "0%" : "-15%" }}>
    <img
      src={logo}
      alt="Logo"
      className="w-16 md:w-28 h-auto"
    />
  </div>

  {/* ✅ Center - Menu */}
  <div className="hidden lg:flex items-center space-x-6 flex-1 justify-center">
    {navItems.map((item) =>
      item.dropdown ? (
        <div key={item.name} className="relative group">
          <button
            className={`flex items-center gap-1 transition-all ${
              active === item.name.toLowerCase()
                ? "text-green-950 font-semibold"
                : "text-gray-700"
            } hover:text-green-800`}
            onClick={() => setActive(item.name.toLowerCase())}
          >
            {item.name}
  <ChevronDown
    className="w-4 h-4 transition-transform duration-300 group-hover:rotate-180"
  />          </button>
          {/* Dropdown */}
          <div className="absolute left-0 mt-2 bg-success shadow-lg  w-52 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
            {item.dropdown.map((drop) => (
              <a
                key={drop.name}
                href={drop.href}
                onClick={() => setActive(drop.name.toLowerCase())}
                className={`block px-4 py-2 transition-colors bg-white ${
                  active === drop.name.toLowerCase()
                    ? "text-green-950 font-semibold"
                    : "text-gray-700"
                } hover:bg-green-950 hover:text-white`}
              >
                {drop.name}
              </a>
            ))}
          </div>
        </div>
      ) : (
        <a
          key={item.name}
          href={item.href}
          onClick={() => setActive(item.name.toLowerCase())}
          className={`relative transition-all ${
            active === item.name.toLowerCase()
              ? "text-green-950 font-semibold after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-full after:h-[2px] after:bg-green-950"
              : "text-gray-700"
          } hover:text-green-800`}
        >
          {item.name}
        </a>
      )
    )}
  </div>

 {/* ✅ Right - Assistance */}
<div
  className="
    flex flex-col text-right flex-shrink-0
    absolute right-[20%] text-end
    lg:static lg:text-right
  "
>
  <span className="text-sm text-gray-600">
    Need Assistance? Let’s Talk!
  </span>
  <a
    href="tel:+918097283444"
    className="text-green-950 font-bold hover:underline"
  >
    +91 8097283444
  </a>
</div>


  {/* ✅ Mobile Hamburger */}
  <button
    onClick={() => setIsOpen(true)}
    className="lg:hidden text-gray-800 ml-auto"
  >
    <Menu size={28} />
  </button>
</div>


      {/* Mobile Fullscreen Menu */}
      <div
        className={`fixed top-0 left-0 h-screen w-screen bg-white transform transition-transform duration-500 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center px-6 py-4 border-b relative">
       
          <button onClick={() => setIsOpen(false)} className="ml-auto">
            <X size={28} className="text-gray-800" />
          </button>
        </div>

        <div className="flex flex-col px-6 py-6 space-y-4 text-lg">
          {navItems.map((item) =>
            item.dropdown ? (
              <div key={item.name}>
                <button
                  className={`flex justify-between items-center w-full ${
                    active === item.name.toLowerCase()
                      ? "text-green-950 font-semibold"
                      : "text-gray-800"
                  }`}
                  onClick={() =>
                    setDropdownOpen(dropdownOpen === item.name ? null : item.name)
                  }
                >
                  {item.name}
                    <ChevronDown
    className={`w-5 h-5 transition-transform duration-300 ${
      dropdownOpen === item.name ? "rotate-180" : ""
    }`}
  />
                </button>
                {dropdownOpen === item.name && (
                  <div className="ml-4 mt-2 flex flex-col space-y-2">
                    {item.dropdown.map((drop) => (
                      <a
                        key={drop.name}
                        href={drop.href}
                        onClick={() => {
                          setActive(drop.name.toLowerCase());
                          setIsOpen(false);
                          setDropdownOpen(null);
                        }}
                        className={`transition-colors ${
                          active === drop.name.toLowerCase()
                            ? "text-green-950 font-semibold"
                            : "text-gray-700"
                        } hover:text-green-950`}
                      >
                        {drop.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <a
                key={item.name}
                href={item.href}
                onClick={() => {
                  setActive(item.name.toLowerCase());
                  setIsOpen(false);
                  setDropdownOpen(null);
                }}
                className={`transition-all ${
                  active === item.name.toLowerCase()
                    ? "text-green-950 font-semibold"
                    : "text-gray-800"
                } hover:text-green-950`}
              >
                {item.name}
              </a>
            )
          )}
        </div>
      </div>
    </nav>
    </>
  
  );
}
